export default __webpack_public_path__ + "static/media/web-development-bw 1.7c34ee50.png";